module.exports = __webpack_public_path__ + "img/loom.cfbbeeb4.svg";